import { createAction, props } from '@ngrx/store'

const commonPrefix = '[common]'

export const show_error_action = createAction(`${commonPrefix} show_error_action`, props<{ data: any; error: any }>())
export const route_to_action = createAction(`${commonPrefix} route_to_action`, props<{ routeTo: string }>())
export const show_display_id_after_created_action = createAction(
  `${commonPrefix} show_display_id_after_created_action`,
  props<{ moduleName: string; displayId: string }>()
)
export const show_success_msg_after_updation_action = createAction(
  `${commonPrefix} show_success_msg_after_updation_action`,
  props<{ moduleName: string }>()
)
export const SAVE_SUMMARY_TABLE_SEARCH_PARAMS = createAction(
  `${commonPrefix} SAVE_SUMMARY_TABLE_SEARCH_PARAMS`,
  props<{ owner: string; data: any }>()
)
export const show_success_msg_after_submit_action = createAction(
  `${commonPrefix} show_success_msg_after_submit_action`,
  props<{ moduleName: string }>()
)